/**
 * Employment status options for medical professionals
 */
export enum EmploymentStatus {
  HOSPITAL_EMPLOYEE = "hospital_employee",
  HEALTH_CENTER_EMPLOYEE = "health_center_employee",
  SECTOR_EMPLOYEE = "sector_employee",
  UNIVERSITY_EMPLOYEE = "university_employee",
  ORGANIZATION_EMPLOYEE = "organization_employee",
  RETIRED = "retired",
  RESIGNED = "resigned",
  FIRED = "fired",
}

/**
 * Array of all employment status values for easy iteration
 */
export const EMPLOYMENT_STATUS_VALUES = Object.values(EmploymentStatus);

/**
 * Employment statuses that are considered "employed" (require workplace fields)
 */
export const EMPLOYED_STATUSES = [
  EmploymentStatus.HOSPITAL_EMPLOYEE,
  EmploymentStatus.HEALTH_CENTER_EMPLOYEE,
  EmploymentStatus.SECTOR_EMPLOYEE,
  EmploymentStatus.UNIVERSITY_EMPLOYEE,
  EmploymentStatus.ORGANIZATION_EMPLOYEE,
];

/**
 * Employment statuses that are considered "not employed" (no workplace fields)
 */
export const NOT_EMPLOYED_STATUSES = [
  EmploymentStatus.RETIRED,
  EmploymentStatus.RESIGNED,
  EmploymentStatus.FIRED,
];

/**
 * Check if employment status requires workplace fields
 */
export const isEmployed = (status: EmploymentStatus | string): boolean => {
  return EMPLOYED_STATUSES.includes(status as EmploymentStatus);
};

/**
 * Human-readable labels for employment status options
 */
export const EMPLOYMENT_STATUS_LABELS: Record<EmploymentStatus, string> = {
  [EmploymentStatus.HOSPITAL_EMPLOYEE]: "Hospital Employee",
  [EmploymentStatus.HEALTH_CENTER_EMPLOYEE]: "Health Center Employee",
  [EmploymentStatus.SECTOR_EMPLOYEE]: "Sector Employee",
  [EmploymentStatus.UNIVERSITY_EMPLOYEE]: "University Employee",
  [EmploymentStatus.ORGANIZATION_EMPLOYEE]: "Organization Employee",
  [EmploymentStatus.RETIRED]: "Retired",
  [EmploymentStatus.RESIGNED]: "Resigned",
  [EmploymentStatus.FIRED]: "Fired",
};
